<div>
  <div class="hub-navbar" [ngClass]="{shadow: showShadow}">
    <div class="nav-background">
      <div class="hub-navbutton">
        <i
          class="fa hubtiger-menu"
          (click)="menuOpen = !menuOpen"
          [ngClass]="{ rotate: !menuOpen }"
        ></i>
      </div>
      <div class="partner-name">Hubtiger Administration</div>
      <div class="menu-right">
        <div class="profile" (click)="dropMenuOpen=!dropMenuOpen">
          <avatar style="margin: auto;margin-right: 8px;" size="40"
                  name="{{ profile.Name === null && profile.Surname === null ?  'No Name' :  (profile.Name + ' ' + profile.Surname) }}"
                  profilePhoto="{{ profile.ImageURL }}"></avatar>
          <a
            href="javascript:void(0)">{{ profile.Name === null && profile.Surname === null ? 'No Name' : (profile.Name + ' ' + profile.Surname)}}</a>
        </div>
        <div class="menu-drop-down" [ngClass]="{'drop-menu-open': !dropMenuOpen}">
          <ul>
            <li routerLink="myprofile" (click)="dropMenuOpen=!dropMenuOpen"><span
              class="fa fa-fw fa-user-o"></span>{{ 'general.my_profile' | translate}}</li>
            <!-- <li routerLink="/clubs"><span
                        class="fa fa-fw fa-bicycle"></span>{{ 'general.cycle_club' | translate}}</li>                                 -->
            <li (click)="logout()"><span class="fa fa-fw fa-sign-out"></span>{{ 'general.logout' | translate}}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="hub-sidebar active" [ngClass]="{'close-menu':!menuOpen, 'shadowDown': showShadow}">
    <div class="hub-navbutton">
      <i
        class="fa hubtiger-close"
        (click)="menuOpen = !menuOpen"
        [ngClass]="{ rotate: !menuOpen }"
      ></i>
    </div>
    <div class="hub-navlogo">
      <img src="../../../../assets/hubtiger_logo_full.png"/>
    </div>
    <!--    <p-menu [model]="superUserMenuItems"></p-menu>-->
    <div class="menu-container main-side-menu">
      <!--      <p-menu [model]="menuItems"></p-menu>-->
      <p-menu [model]="superUserMenuItems">
        <ng-template pTemplate="item" let-item class="main-menu-item">
          <a class="p-menuitem-link flex align-items-center p-3" [routerLink]="item.routerLink"
             [routerLinkActive]="'p-menuitem-link-active'">

            <span class="menu-icon"><daz-icon [name]="item.icon" [size]="'26px'"
                                              [color]="'var(--hubtiger-contrast)'"></daz-icon></span>
            <span class="menu-label ml-2"> {{ item.label }}</span>
            <span class="arrow-right"><daz-icon [name]="'arrow-right'" [size]="'24px'"
                                                [color]="'var(--hubtiger-negative)'"></daz-icon></span>

          </a>
        </ng-template>


      </p-menu>
    </div>
    <p-panelMenu [transitionOptions]="'400ms'" [model]="superUserToolsItems" [multiple]=false>
    </p-panelMenu>
  </div>
  <div class="hub-content" [ngClass]="{'close-menu-content':!menuOpen}">
    <div class="hub-content-background"></div>
    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
